import { Directive, input, effect, ElementRef, Renderer2, inject, signal } from '@angular/core';

@Directive({
  selector: 'button[btnLoading]',
  standalone: true,
  host: {
    '[class.btn-loading-active]': 'btnLoading()',
    '[attr.aria-busy]': 'btnLoading()',
    '[style.position]': "'relative'"
  }
})
export class BtnLoadingDirective {
  btnLoading = input<boolean>(false);

  private el = inject(ElementRef<HTMLButtonElement>);
  private renderer = inject(Renderer2);
  private spinnerElement = signal<HTMLElement | null>(null);

  constructor() {
    // Inyectamos los estilos manualmente al DOM ya que @Directive no soporta 'styles'
    this.injectStyles();

    effect(() => {
      const isLoading = this.btnLoading();
      const button = this.el.nativeElement;

      if (isLoading) {
        this.setLoadingState(button);
      } else {
        this.resetState(button);
      }
    });
  }

  private injectStyles() {
    // Verificamos si el estilo ya existe para no duplicarlo
    if (document.getElementById('btn-loading-styles')) return;

    const style = this.renderer.createElement('style');
    style.id = 'btn-loading-styles';
    style.innerHTML = `
      .spinner-border-sm-custom {
        width: 1rem;
        height: 1rem;
        border: 0.2em solid currentColor;
        border-right-color: transparent;
        border-radius: 50%;
        display: inline-block;
        animation: btn-loading-spinner .75s linear infinite;
      }
      @keyframes btn-loading-spinner {
        to { transform: rotate(360deg); }
      }
    `;
    this.renderer.appendChild(document.head, style);
  }

  private setLoadingState(button: HTMLButtonElement) {
    this.renderer.setAttribute(button, 'disabled', 'true');

    // Ocultar texto (soporta Material y botones estándar)
    const textElement = button.querySelector('.mdc-button__label') || button.querySelector('span');
    if (textElement) {
      this.renderer.setStyle(textElement, 'opacity', '0');
    }

    if (!this.spinnerElement()) {
      const span = this.renderer.createElement('span');
      this.renderer.addClass(span, 'spinner-border-sm-custom');

      // Centrado absoluto
      this.renderer.setStyle(span, 'position', 'absolute');
      this.renderer.setStyle(span, 'top', 'calc(50% - 0.5rem)');
      this.renderer.setStyle(span, 'left', 'calc(50% - 0.5rem)');
      this.renderer.setStyle(span, 'color', 'inherit');

      this.renderer.appendChild(button, span);
      this.spinnerElement.set(span);
    }
  }

  private resetState(button: HTMLButtonElement) {
    this.renderer.removeAttribute(button, 'disabled');

    const textElement = button.querySelector('.mdc-button__label') || button.querySelector('span');
    if (textElement) {
      this.renderer.setStyle(textElement, 'opacity', '1');
    }

    const spinner = this.spinnerElement();
    if (spinner) {
      this.renderer.removeChild(button, spinner);
      this.spinnerElement.set(null);
    }
  }
}